export default {"src":"/_next/static/media/collapse-close.dc0c9620.svg","height":152,"width":171,"blurWidth":0,"blurHeight":0};